import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import TrackerEstimateBurnedCaloriesMutation from './TrackerEstimateBurnedCaloriesMutation';

interface ITrackerEstimateBurnedCaloriesConnectorApolloProps {
  children: ({
    estimateBurnedKcals,
    cancelEstimateBurnedKcals,
  }: {
    estimateBurnedKcals: (input: any) => Promise<any>;
    cancelEstimateBurnedKcals: () => void;
  }) => React.ReactElement;
}

const TrackerEstimateBurnedCaloriesConnectorApollo: React.FC<
  ITrackerEstimateBurnedCaloriesConnectorApolloProps
> = ({ children }) => {
  const [estimateBurnedKcalsMutation] = useMutation(TrackerEstimateBurnedCaloriesMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const estimateBurnedKcals = async (input: any) => {
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();

    const response = await estimateBurnedKcalsMutation({
      variables: { input },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data.dailyTracker.estimateBurnedKcals;
  };

  const cancelEstimateBurnedKcals = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ estimateBurnedKcals, cancelEstimateBurnedKcals });
};

export default TrackerEstimateBurnedCaloriesConnectorApollo;
